import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import axios, { AxiosInstance } from 'axios';
import { KeycloakAuthService } from '../core/services/keycloak-auth.service';
import { ApiConfigService } from '../core/services/api-config.service';

export interface EventsRegistration {
  EventCode: string;
  EventType: string;
  EventFields: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private api: AxiosInstance | null = null;
  private platformId = inject(PLATFORM_ID);
  private authService = inject(KeycloakAuthService);
  private apiConfig = inject(ApiConfigService);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.api = axios.create({
        headers: {
          'Content-Type': 'application/json'
        }
      });

      // Add request interceptor to dynamically set baseURL and include OAuth token
      this.api.interceptors.request.use((config) => {
        // Dynamically construct baseURL on each request to get current tenantId
        const baseUrl = this.apiConfig.getApiBaseUrl();
        const tenantId = this.apiConfig.getTenantId();
        config.baseURL = `${baseUrl}/${tenantId}`;

        const token = this.authService.accessToken;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      });
    }
  }

  async getEventRegistration(): Promise<Array<EventsRegistration> | null> {
    if (!this.api) return null;

    try {
      const response = await this.api.get('/event/registration');
      return response.data;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  }
}
